import { useAuth } from "../../../hooks/useAuth";
import { usePostHog } from "posthog-js/react";
import { useNavigation } from "@react-navigation/native";
import { useSetOnboardingStatusMutation } from "@axio/graphql/generated/graphql";
import OnboardMenu from "../../../components/onboarding/OnboardMenu/OnboardMenu";
import { useAppConfig } from "../../../AppConfigProvider";

function OnboardMenuContainer() {
  const appConfig = useAppConfig();

  const { logout, refetchMe } = useAuth();
  const posthog = usePostHog();
  const navigation = useNavigation();

  const isCompanionMode = appConfig.isCompanionMode;

  const [setOnboardingStatus] = useSetOnboardingStatusMutation();

  const handleLogoutPress = () => {
    logout();
  };

  const handleSkipPress = async () => {
    posthog?.capture("Onboarding Skipped");
    await setOnboardingStatus({
      variables: {
        isOnboarded: true,
      },
    });

    await refetchMe();

    if (isCompanionMode) {
      navigation.navigate("Companion Home");
    } else {
      navigation.navigate("Home");
    }
  };

  return <OnboardMenu onLogout={handleLogoutPress} onSkip={handleSkipPress} />;
}

export default OnboardMenuContainer;
